import stationIcon from '../../assets/images/icon-station.png'
import machinesIcon from '../../assets/images/icon-machines.png'
import simCardIcon from '../../assets/images/icon-sim-card.png'
import sdCardIcon from '../../assets/images/icon-sd-card.png'
import relationIcon from '../../assets/images/icon-relation.png'
import salesDataIcon from '../../assets/images/icon-sales-data.png'
import ordersIcon from '../../assets/images/icon-orders.png'
import itemsIcon from '../../assets/images/icon-items.png'
import itemPriceHistoryIcon from '../../assets/images/icon-item-price-history.png'
import plusIcon from '../../assets/images/icon-plus.png'
import rankingIcon from '../../assets/images/icon-ranking.png'
import promotionCampaignsIcon from '../../assets/images/icon-promotion-campaigns.png'
import autoEntryCampaignsIcon from '../../assets/images/icon-auto-entry-campaigns.png'
import usersIcon from '../../assets/images/icon-users.png'
import promotionImagesIcon from '../../assets/images/promotion-images.png'
import emergenciesIcon from '../../assets/images/icon-emergencies.png'
import machineErrorIcon from '../../assets/images/icon-machine-errors.png'
import pointsIcon from '../../assets/images/icon-points.png'
import stationAlertIcon from '../../assets/images/icon-station-alert.png'
import subscriptionIcon from '../../assets/images/icon-subscription.png'
import signageBannerIcon from '../../assets/images/icon-signage-banner.png'
import streamingIcon from '../../assets/images/icon-streaming.png'
import screenShareIcon from '../../assets/images/icon-screen-share.png'
import kioskIcon from '../../assets/images/icon-kiosk.png'
import kioskItemPriceIcon from '../../assets/images/icon-kiosk-item-price.png'
import preMakingIcon from '../../assets/images/icon-pre-making.png'
import deliveryIcon from '../../assets/images/icon-delivery.png'
import foodIcon from '../../assets/images/icon-food.png'
import {
  roleType,
  Permission,
  ALLOWED_ACCESS_FOR_ALL,
  ALLOWED_ACCESS_FOR_SBJ_ADMIN,
  ALLOWED_ACCESS_FOR_SBJ_ROLES,
  ALLOWED_ACCESS_ROOT_ONLY,
} from '../../../core/auth0'

export interface SidebarContent {
  id: string
  label: string
  url: string
  icon: string
  allowedAccessRolls: roleType[]
  requiredPermission?: Permission
  subMenu?: SidebarContent[]
}

export interface SidebarHeaderContent {
  company: string
  service: string
}

export const sidebarContent: SidebarContent[] = [
  {
    id: 'sales_data',
    label: '売上データ',
    url: '/sales_data',
    icon: salesDataIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ROLES,
    requiredPermission: Permission.SBJ_SALES_DATA_READ,
  },
  {
    id: 'orders',
    label: 'オーダー管理',
    url: '/orders',
    icon: ordersIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_ALL,
    requiredPermission: Permission.ORDER_READ,
  },
  {
    id: 'pre_making',
    label: '事前調理',
    url: '/pre_making',
    icon: preMakingIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_ALL,
    requiredPermission: Permission.ITEM_READ,
  },
  {
    id: 'emergencies',
    label: 'エマージェンシー履歴',
    url: '/emergencies',
    icon: emergenciesIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ROLES,
    requiredPermission: Permission.EMERGENCY_HISTORY_READ,
  },
  {
    id: 'station',
    label: 'デバイス',
    url: '',
    icon: '',
    allowedAccessRolls: ALLOWED_ACCESS_FOR_ALL,
    subMenu: [
      {
        id: 'stations',
        label: 'ステーション',
        url: '/stations',
        icon: stationIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_ALL,
        requiredPermission: Permission.STATION_READ,
      },
      {
        id: 'machines',
        label: 'マシン',
        url: '/machines',
        icon: machinesIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.MACHINE_READ,
      },
      {
        id: 'kiosks',
        label: 'KIOSK',
        url: '/kiosks',
        icon: kioskIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.KIOSK_READ,
      },
      {
        id: 'soracom_sims',
        label: 'SIM',
        url: '/soracom_sims',
        icon: simCardIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.SIM_READ,
      },
      {
        id: 'machine_embedded_computers',
        label: 'SDカード',
        url: '/machine_embedded_computers',
        icon: sdCardIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.SD_CARD_READ,
      },
      {
        id: 'machine_relations',
        label: 'マシン紐付け',
        url: '/machine_relations',
        icon: relationIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.MACHINE_LINK_READ,
      },
      {
        id: 'kiosk_relations',
        label: 'KIOSK紐付け',
        url: '/kiosk_relations',
        icon: relationIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.KIOSK_LINK_READ,
      },
    ],
  },
  {
    id: 'admin_users',
    label: '管理ユーザー',
    url: '/admin_users',
    icon: usersIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
    requiredPermission: Permission.ADMIN_USER_READ,
  },
  {
    id: 'users',
    label: 'ユーザー',
    url: '/users',
    icon: usersIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_ALL,
    requiredPermission: Permission.USER_READ,
  },
  {
    id: 'item',
    label: 'コーヒー',
    url: '',
    icon: '',
    allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
    subMenu: [
      {
        id: 'items',
        label: 'コーヒー一覧',
        url: '/items',
        icon: itemsIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
        requiredPermission: Permission.ITEM_READ,
      },
      {
        id: 'item_price_history',
        label: '価格変更履歴',
        url: '/item_price_history',
        icon: itemPriceHistoryIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
        requiredPermission: Permission.ITEM_READ,
      },
      {
        id: 'new_item',
        label: 'コーヒー追加',
        url: '/items/new',
        icon: plusIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
        requiredPermission: Permission.ITEM_CREATE,
      },
      {
        id: 'station_with_item_ranks',
        label: 'ランキング',
        url: '/station_with_item_ranks',
        icon: rankingIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.ITEM_RANKING_READ,
      },
      {
        id: 'kiosk_item_prices',
        label: 'KIOSK価格',
        url: '/kiosk_item_prices',
        icon: kioskItemPriceIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.KIOSK_PRICE_READ,
      },
    ],
  },
  {
    id: 'food',
    label: 'フード',
    url: '',
    icon: '',
    allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
    subMenu: [
      {
        id: 'foods',
        label: 'フード一覧',
        url: '/foods',
        icon: foodIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
        requiredPermission: Permission.FOOD_READ,
      },
      {
        id: 'food_price_history',
        label: '価格変更履歴',
        url: '/food_price_history',
        icon: itemPriceHistoryIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
        requiredPermission: Permission.ITEM_READ,
      },
      {
        id: 'new_food',
        label: 'フード追加',
        url: '/foods/new',
        icon: plusIcon,
        allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
        requiredPermission: Permission.FOOD_CREATE,
      },
    ],
  },
  {
    id: 'signage_banner',
    label: 'サイネージバナー',
    url: '/signage_banner',
    icon: signageBannerIcon,
    allowedAccessRolls: ALLOWED_ACCESS_FOR_SBJ_ADMIN,
    requiredPermission: Permission.SIGNAGE_BANNER_READ,
  },
  {
    id: 'points',
    label: 'ポイント',
    url: '/points',
    icon: pointsIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    requiredPermission: Permission.POINT_READ,
  },
  {
    id: 'campaigns',
    label: 'クーポン',
    url: '',
    icon: '',
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    subMenu: [
      {
        id: 'promotion_campaigns',
        label: '手動発行クーポン',
        url: '/promotion_campaigns',
        icon: promotionCampaignsIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.MANUAL_COUPON_READ,
      },
      {
        id: 'auto_entry_campaigns',
        label: '自動発行クーポン',
        url: '/auto_entry_campaigns',
        icon: autoEntryCampaignsIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.AUTO_COUPON_READ,
      },
    ],
  },
  {
    id: 'point_exchange',
    label: 'ポイント交換',
    url: '',
    icon: '',
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    subMenu: [
      {
        id: 'point_items',
        label: 'グッズ',
        url: '/point_items',
        icon: itemsIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.POINT_EXCHANGE_GOODS_READ,
      },
      {
        id: 'point_item_support_logs',
        label: 'グッズ発送管理',
        url: '/point_item_support_logs',
        icon: deliveryIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.GOODS_SHIPPING_READ,
      },
      {
        id: 'point_item_orders',
        label: 'グッズ受注管理',
        url: '/point_item_orders',
        icon: deliveryIcon,
        allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
        requiredPermission: Permission.GOODS_ORDER_READ,
      },
    ],
  },
  {
    id: 'promotion_images',
    label: 'アプリバナー',
    url: '/promotion_images',
    icon: promotionImagesIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    requiredPermission: Permission.APP_BANNER_READ,
  },
  {
    id: 'station_alerts',
    label: 'アプリお知らせ',
    url: '/station_alerts',
    icon: stationAlertIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    requiredPermission: Permission.APP_NOTIFICATION_READ,
  },
  {
    id: 'machine_errors',
    label: 'マシン通知履歴',
    url: '/machine_errors',
    icon: machineErrorIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    requiredPermission: Permission.MACHINE_ERROR_HISTORY_READ,
  },
  {
    id: 'subscriptions',
    label: 'サブスクリプション',
    url: '/subscriptions',
    icon: subscriptionIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    requiredPermission: Permission.SUBSCRIPTION_HISTORY_READ,
  },
  {
    id: 'camera',
    label: 'リアルタイム配信',
    url: '/streaming_viewer',
    icon: streamingIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
  },
  {
    id: 'vnc_link',
    label: 'VNC接続',
    url: '/vnc_link',
    icon: screenShareIcon,
    allowedAccessRolls: ALLOWED_ACCESS_ROOT_ONLY,
    requiredPermission: Permission.VNC_CONNECT,
  },
]

export const sidebarHeaderContent: SidebarHeaderContent = {
  company: 'root C Dashboard',
  service: 'New Innovations',
}
